import { h, render, Component } from 'preact';
import FilterItem from './catalog/FilterItem';
import ProductPreview from './catalog/ProductPreview';
import PageHeader from './components/PageHeader';
import Paginator from './components/paginator';
import Filterer from './libs/Filterer';
import pubsub from './pubsub.js';
import StickyBox from "react-sticky-box";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import RangeValue from "./libs/RangeValue";
import SharedFiltersStore from "./catalog/store/SharedFiltersStore";

class Catalog extends Component {

    state = {
        products: window.products,
        filters: window.filters,
        lines: window.lines,
        currentLine: null
    }

    onFilterReset = () => {
        document.getElementById('catalogue__filter__form__mobile')?.reset();
        document.getElementById('catalogue__filter__form')?.reset();

        this.filterer.setFilters({}, false);
        SharedFiltersStore.reset();
    }

    onFilterChange = (propertyId, value) => {
        this.filterer.updateFilter(propertyId, value)
    }

    onChangeLine(id, e) {
        e.preventDefault();

        this.filterer.setLine(id)
    }

    onChangePage = (page) => {
        this.changePageTime = new Date();
        this.filterer.setPage(page);
    }

    onLoadNextPage = () => {
        this.filterer.incrementPage();
    }

    componentWillMount() {
        // console.info('products', this.state.products);
        // console.info('filters', this.state.filters);
        // console.info('linse', window.lines);
        this.filterer = new Filterer(this.state.products, this.state.lines);
        this.filterer.onUpdate((selectedFilters, currentLine) => {
            this.state.currentLine = currentLine;
            this.forceUpdate();
        })
    }

    componentDidUpdate() {
        if(this.changePageTime instanceof Date) {
            if(new Date() - this.changePageTime < (5 * 1000)) {
                this.changePageTime = null;
                if(typeof(document.body.scrollIntoView) === 'function' && this.mainEl) {
                    this.mainEl.scrollIntoView({
                        block: "start", behavior: "smooth"
                    })
                }
            }
        }
    }

    componentDidMount() {
        let wh = window.innerHeight;
        let list = document.querySelector('.catalogue__list');

        window.addEventListener('resize', function() {
            wh = window.innerHeight;
        })

        pubsub.on('page.scroll', st => {
            if(st > (list.offsetTop + list.clientHeight - wh)) {
                this.onLoadNextPage();
            }
        });
    }

    renderPageHeader() {
        const { currentLine = null } = this.state;

        if(currentLine) {
            return (
                <PageHeader
                    title={currentLine.title}
                    titleStyle={currentLine.titleColor ? {color: currentLine.titleColor} : {}}
                    backgroundSrc={currentLine.headerImageSrc}
                    path={
                        window.breadcrumbs.concat(currentLine.title, null)
                    }>
                    <p
                        class="page-header__description"
                        style={
                            currentLine.titleColor
                                ? {color: currentLine.titleColor}
                                : {}
                        }>
                        {currentLine.description}
                    </p>

                    <a
                        href="#"
                        onClick={this.onChangeLine.bind(this, null)}
                        class="page-header__button icon-button _catalogue"
                        >
                        <svg>
                            <use xlinkHref="#catalogue_icon" x="0" y="0" />
                        </svg>
                        Все {window.category.title}
                    </a>
                </PageHeader>
            )
        }
        else {
            return (
                <PageHeader
                    title={window.breadcrumbs[window.breadcrumbs.length-1][0]}
                    path={window.breadcrumbs || null}
                    footer={() => {
                        return (<nav class="catalogue__product-lines">
                            {
                                this.state.lines.map(line => {
                                    return (
                                        <a
                                            href={line.url}
                                            data-line-id={line.id}
                                            onClick={this.onChangeLine.bind(this, line.id)} 
                                            class="catalogue__product-lines__item"
                                            style={line.titleColor ? {color: line.titleColor} : {}}>
                                            <span class="catalogue__product-lines__item__label">
                                                {line.shortTitle}
                                            </span>
                                            <div
                                                class="catalogue__product-lines__item__bg"
                                                style={
                                                    line.listImageSrc
                                                        ? {backgroundImage: `url(${line.listImageSrc})`}
                                                        : {}
                                                    }
                                                >
                                            </div>
                                        </a>
                                    )
                                })
                            }
                        </nav>)
                    }}>
                </PageHeader>
            )
        }
    }

    bindMainRef = el => this.mainEl = el

    render(props, state) {
        const products = this.filterer.getData();

        const onChangeLine = this.onChangeLine.bind(this);
        const filtersCount = Object
            .entries(this.filterer.selectedFilters)
            .map(([keys, values]) => {
                if (typeof values == 'boolean') {
                    return 1;
                }

                if (values instanceof RangeValue) {
                    return values.hasValues() ? 1 : 0;
                }

                return values.length;
            })
            .reduce((a, b) => a + b, 0);

        return (
            <section class="catalogue">
                { this.renderPageHeader() }
                <div class="catalogue__content wrapper">
                    <aside class="catalogue__filter">
                        <StickyBox offsetTop={60} offsetBottom={20}>
                            <fieldset class="catalogue__filter__group count">
                                <AlertDialog.Root>
                                    <AlertDialog.Trigger asChild>
                                        <div>
                                            <span class="catalogue__filter__selected__count">
                                                Фильтров выбрано: {filtersCount}
                                            </span>
                                            <button class={`catalogue__filter__button button button_style-accidental`}>
                                                <svg class="catalogue__filter__icon" height="24" width="24">
                                                    <use xlinkHref="#filter_icon" x="0" y="0" />
                                                </svg>
                                                <span class="button__wrapper">
                                                    Фильтры {filtersCount > 0 ? `(${filtersCount})` : ''}
                                                </span>
                                            </button>
                                        </div>
                                    </AlertDialog.Trigger>
                                    <AlertDialog.Portal>
                                        <AlertDialog.Overlay className="AlertDialogOverlay" />
                                        <AlertDialog.Content className="AlertDialogContent">
                                            <AlertDialog.Title className="AlertDialogTitle">
                                            </AlertDialog.Title>
                                            <AlertDialog.Description className="AlertDialogDescription">
                                            </AlertDialog.Description>

                                            <AlertDialog.Cancel asChild>
                                                <div class="catalogue__filter__modal__close__wrapper">
                                                    <div class="catalogue__filter__modal__close"></div>
                                                </div>
                                            </AlertDialog.Cancel>
                                            <form
                                                id="catalogue__filter__form__mobile"
                                                class="catalogue__filter__form catalogue__filter__form__mobile"
                                                onReset={this.onFilterReset}>
                                                {
                                                    this.state.filters.map((filter, key) => {
                                                        return (
                                                            <FilterItem
                                                                {...filter}
                                                                sharedFilterId={filter.propertyId}
                                                                onChange={this.onFilterChange} />
                                                        )
                                                    })
                                                }
                                                <fieldset class="catalogue__filter__group reset">
                                                    <div class={`catalogue__filter__form_reset_wrapper ${this.filterer.hasFilters() ? '' : 'reset__hidden'}`}>
                                                        <button
                                                            type="reset"
                                                            class="button button_style-accidental">
                                                    <span class="button__wrapper">
                                                        Сбросить фильтр
                                                    </span>
                                                        </button>
                                                    </div>
                                                </fieldset>
                                            </form>
                                        </AlertDialog.Content>
                                    </AlertDialog.Portal>
                                </AlertDialog.Root>
                            </fieldset>

                            <form
                                id="catalogue__filter__form"
                                class="catalogue__filter__form desktop"
                                onReset={this.onFilterReset}>
                                {
                                    this.state.filters.map((filter, key) => {
                                        return (
                                            <FilterItem
                                                {...filter}
                                                sharedFilterId={filter.propertyId}
                                                onChange={this.onFilterChange} />
                                        )
                                    })
                                }
                                <fieldset class="catalogue__filter__group">
                                    <div class={`catalogue__filter__form_reset_wrapper ${this.filterer.hasFilters() ? '' : 'reset__hidden'}`}>
                                        <button
                                            type="reset"
                                            class="button button_style-accidental">
                                                    <span class="button__wrapper">
                                                        Сбросить фильтр
                                                    </span>
                                        </button>
                                    </div>
                                </fieldset>
                            </form>
                        </StickyBox>
                    </aside>

                    <main class="catalogue__main" ref={this.bindMainRef} style="position: sticky; top: 60">
                        {
                            products.length
                                ? 
                                    <ul class="catalogue__list">
                                        {
                                            products.map(product => {
                                                return (
                                                    <ProductPreview
                                                        {...product}
                                                        class="catalogue__list__item" />
                                                )
                                            })
                                        }
                                        {
                                            <li class="product-preview catalogue__list__item-plug"></li>
                                        }
                                        {
                                            <li class="product-preview catalogue__list__item-plug"></li>
                                        }
                                    </ul>
                                :
                                    <div class="informer _accidental catalogue__informer">
                                        Нет подходящих товаров.<br/>
                                        Попробуйте смягчить условия фильтра
                                        <br/>
                                        <button type="reset" class="button button_style-common" style={{marginTop: 10}} onClick={this.onFilterReset}>
                                            <span class="button__wrapper">Сбросить фильтр</span>
                                        </button>
                                    </div>
                        }

                        {
                            !this.filterer.isLastPage()
                                ?
                                    <button
                                        class="icon-button _load"
                                        onClick={this.onLoadNextPage}>
                                        <svg>
                                            <use xlinkHref="#load_icon" x="0" y="0" />
                                        </svg>
                                        Загрузить ещё
                                    </button>
                                : null
                        }

                        {/*<Paginator
                            pages={this.filterer.getPages()}
                            currentPage={this.filterer.getCurrentPage()}
                            onPage={this.onChangePage} />
                        */}
                    </main>
                </div>
            </section>
        )
    }
}

export default function() {
    const wrapper = document.getElementById('catalog');

    if(wrapper) {
        wrapper.innerHTML = '';

        render(<Catalog />, wrapper);
    }
}
